import {BREADCRUMB_ORBIT_CLUSTER_PATH} from "../actions/types";

const INITIAL_STATE = {
    orbitClusterPath: []
};

export const breadCrumbReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case BREADCRUMB_ORBIT_CLUSTER_PATH:
            return {
                ...state,
                orbitClusterPath: action.payload.orbitClusterPath
            };

        default:
            return state;
    }
};
